import { useEffect, useState } from "react";

export function useHeaderScrolled(threshold = 12) {
	const [scrolled, setScrolled] = useState(false);

	useEffect(() => {
		const sync = () => setScrolled(window.scrollY > threshold);
		sync();
		window.addEventListener("scroll", sync, { passive: true });
		return () => window.removeEventListener("scroll", sync);
	}, [threshold]);

	return scrolled;
}
